<template>
  <b-row>
    <b-col>
      <b-row v-if="isLoading" class="justify-content-md-center">
        <b-col lg="6">
          <div class="d-flex justify-content-center">
            <b-spinner label="Loading..." variant="dark" />
          </div>
        </b-col>
      </b-row>

      <b-row v-else>
        <b-col v-if="ultimateLearningOutcome">
          <learning-outcome-tree
            :learning-unit-id="learningUnit.id"
            :section-id="section.id"
            :learning-outcome="ultimateLearningOutcome"
            hide-shift
            hide-setting
            hide-create-ultimate-lo
            hide-create-criteria-ultimate-lo
            hide-create-criteria-sub-lo
            show-only-has-criteria
            :hide-create-assessment-criteria="false"
            :hide-assessment-criteria="false"
            :disabled="disabled"
          >
          </learning-outcome-tree>
        </b-col>

        <b-col v-else class="text-center">
          <div ref="text_no-lo" class="text-dark mt-3 text__no-lo">No learning outcomes</div>

          <!-- <b-button
            ref="button__create-ultimate-lo"
            class="button__create-ultimate-lo mt-2"
            variant="first"
            @click="showModalUltimateLearningOutcome = true"
            >Create an ultimate learning outcome</b-button
          > -->
        </b-col>
      </b-row>
    </b-col>

    <!-- <modal-create-or-update-ultimate-learning-outcome
      :learning-unit-id="learningUnit.id"
      :ultimate-learning-outcome="ultimateLearningOutcome"
      :show.sync="showModalUltimateLearningOutcome"
    /> -->
  </b-row>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
import LearningOutcome from '@/models/LearningOutcome';
import Section from '@/models/Section';
import User from '@/models/User';
import LearningOutcomeTree from '@/components/LearningOutcome/LearningOutcomeTree';
import { PostSchedule } from '../../models';
// import ModalCreateOrUpdateUltimateLearningOutcome from "@/components/LearningOutcome/ModalCreateOrUpdateUltimateLearningOutcome";

export default {
  components: {
    LearningOutcomeTree
    // ModalCreateOrUpdateUltimateLearningOutcome,
  },
  props: {
    user: {
      type: User,
      default: () => null,
      require: true
    },

    learningUnit: {
      type: LearningUnit,
      required: true
    },

    section: {
      type: Section,
      default: () => null
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    }
  },

  data() {
    return {
      isLoading: false
      // showModalUltimateLearningOutcome: false,
    };
  },

  computed: {
    ultimateLearningOutcome() {
      return LearningOutcome.find(this.learningUnit.ultimate_learning_outcome_id);
    }
  },

  async mounted() {
    await this.fetch();
  },

  methods: {
    async fetch() {
      if (this.learningUnit.ultimate_learning_outcome_id) {
        this.isLoading = true;

        try {
          await PostSchedule.api().findForTeacher(this.section.id);
        } catch (error) {
          console.log(error);
        } finally {
          this.isLoading = false;
        }
      }
    }
  }
};
</script>
